var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownwardArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99891 6.01999L1.17891 0.20999C1.04891 0.0799899 0.868906 0.00999018 0.688906 0.00999019C0.508906 0.00999019 0.328906 0.0799899 0.198906 0.20999C-0.0610941 0.46999 -0.0610941 0.92999 0.198906 1.18999L6.99891 7.98999L13.7989 1.18999C13.9289 1.05999 13.9989 0.879989 13.9989 0.69999C13.9989 0.51999 13.9289 0.33999 13.7989 0.209989C13.6689 0.0799893 13.4889 0.00998963 13.3089 0.00998963C13.1289 0.00998964 12.9489 0.0799893 12.8189 0.209989L6.99891 6.01999Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownwardArrowIcon);
export default __webpack_public_path__ + "static/media/downwardArrowIcon.bdb536564455943638d14e0be25515f5.svg";
export { ForwardRef as ReactComponent };